import Vue from 'vue'
import Vuex from 'vuex'

import { login, dataReport, etcd, home, advertise, staff, subAccountGlobal, operationLog } from '@/global/store'
import accountInfo from './modules/accountInfo'
import financial from './modules/financial'
import adUserAdvertise from './modules/advertise'
import group from './modules/group'
import plan from './modules/plan'
import creation from './modules/creation'
import promotion from './modules/promotion'
import channel from './modules/channel'
import promotionData from './modules/promotion-data'
import transferEvent from './modules/transferEvent'
import audience from './modules/audience'
import track from './modules/track'
// import { storeApiPlugin } from '../http';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    home: {
      namespaced: true,
      ...home
    },
    login: {
      namespaced: true,
      ...login
    },
    etcd: {
      namespaced: true,
      ...etcd
    },
    dataReport: {
      namespaced: true,
      ...dataReport
    },
    account: {
      namespaced: true,
      ...accountInfo
    },
    finance: {
      namespaced: true,
      ...financial
    },
    global: {
      namespaced: true,
      modules: {
        advertise: {
          namespaced: true,
          ...advertise
        },
        subAccount: {
          namespaced: true,
          ...subAccountGlobal
        },
        operationLog: {
          namespaced: true,
          ...operationLog
        }
      }
    },
    advertise: {
      namespaced: true,
      ...adUserAdvertise
    },
    staff: {
      namespaced: true,
      ...staff
    },
    group: {
      namespaced: true,
      ...group
    },
    plan: {
      namespaced: true,
      ...plan
    },
    creation: {
      namespaced: true,
      ...creation
    },
    promotion,
    channel,
    promotionData,
    transferEvent,
    audience: {
      namespaced: true,
      ...audience
    },
    track: {
      namespaced: true,
      ...track
    }
  }
  // plugins: [storeApiPlugin]
})
